const DealerDashboard = () => {
  return <div>Dealer Dashboard</div>;
};

export default DealerDashboard;
